// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "7fb4ccbe6981277423da3af4f961744d" + ".js";
};